import { motion } from "framer-motion";
import { Footprints, Car, ArrowDown } from "lucide-react";
import { formatDistance } from "../lib/travel";

export function TravelLeg({ leg, index }) {
  if (!leg) return null;
  const walk = leg.mode === "walk";
  const Icon = walk ? Footprints : Car;
  return (
    <motion.div
      data-testid={`travel-leg-${index}`}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.4, delay: 0.3 + index * 0.12 }}
      className="flex items-center gap-3 pl-[1.35rem] -my-2"
    >
      <div className="flex flex-col items-center text-muted-foreground/60">
        <span className="h-3 w-px bg-border" />
        <ArrowDown size={12} />
        <span className="h-3 w-px bg-border" />
      </div>
      <div
        className={`inline-flex items-center gap-2 rounded-full border px-3 py-1.5 text-xs font-semibold ${
          walk ? "border-border bg-secondary/60 text-foreground" : "border-neon-amber/40 bg-secondary/60 text-foreground"
        }`}
      >
        <Icon size={14} className={walk ? "neon-cyan" : "text-amber-400"} />
        <span data-testid={`travel-leg-text-${index}`}>
          {walk ? `${leg.minutes} min walk` : `~${leg.minutes} min ride`}
        </span>
        <span className="text-muted-foreground">· {formatDistance(leg.km)}</span>
        {!walk && (
          <span className="text-muted-foreground hidden sm:inline">· {leg.walkMin} min on foot</span>
        )}
      </div>
    </motion.div>
  );
}
